import {FC, useEffect, useState} from 'react';
import styled from '@emotion/styled';
// custom
import { getSubText } from '../../common/helpers/CommonUtil';
import SimpleSpinner from '../loaders/spinners/SimpleSpinner';
import { IPromotion } from '../../common/state/promotions/promotion';

type IPromotionTableProps = {
    list: IPromotion[] | undefined,    
    onEdit: (data : IPromotion) => void,
    onDelete: (data : IPromotion) => void
};

const ContainerStyled = styled.section`
    width: 100%;
    min-height: 300px;
    max-height: 600px;
    table {
        width: 100%
    }
`;

const PromotionTableAdmin : FC <IPromotionTableProps> = ({list, onEdit, onDelete}) => {
    // states
    const [title, setTitle] = useState<string>('');
    const [subTitle, setSubTitle] = useState<string>('Please wait...');    

    // lifecycle
    useEffect(()=>{
        if (list && list.length > 0) {
            setTitle('Promotion Offers Detail');
            setSubTitle('Promotion records breakdown with their corresponding discount...');
        } else if (list && list.length === 0) {
            setTitle('No Promotion offers');
            setSubTitle('There are currently no promotion offers available. Click on + to create a promotion');
        }
    },[list]);
    // lifecycle methods
    function populateTable(): JSX.Element {
        return <table
        className="relative w-fit table-auto border-2 border-slate-400 rounded text-gray-700 dark:text-gray-300">
        <thead className='text-gray-700 dark:text-gray-700'>
            <tr>
                <th className="py-2 px-1 border-2 border-slate-400 rounded bg-gray-300">#</th>
                <th className="px-4 py-2 border-2 border-slate-400 rounded bg-gray-300">Promo code</th>
                <th className="px-4 py-2 border-2 border-slate-400 rounded bg-gray-300">Description</th>
                <th className="px-4 py-2 border-2 border-slate-400 rounded bg-gray-300">Discount (%)</th>                                
                <th className="px-4 py-2 border-2 border-slate-400 rounded bg-gray-300">Start Date</th>                                
                <th className="px-4 py-2 border-2 border-slate-400 rounded bg-gray-300">End Date</th>                
                <th className="px-4 py-2 border-2 border-slate-400 rounded bg-gray-300">Actions</th>                
            </tr>
        </thead>
        <tbody>
            {list && list.map((item: IPromotion, index: number)=> {
                const startDate = new Date(item.start_date);
                const endDate = new Date(item.end_date);      
                return <tr key={index}>
                    <td className="border px-1 py-2 border-2 border-slate-400 rounded text-center">{index+1}</td>
                    <td className="border px-4 py-2 border-2 border-slate-400 rounded">{item.promo_code.toUpperCase()}</td>
                    <td className="border px-4 py-2 border-2 border-slate-400 rounded">{getSubText(item.description, 80)}</td>
                    <td className="border px-4 py-2 border-2 border-slate-400 rounded">{item.discount.toFixed(1)}%</td>
                    <td className="border px-4 py-2 border-2 border-slate-400 rounded">{startDate.toDateString()}</td>                    
                    <td className="border px-4 py-2 border-2 border-slate-400 rounded">{endDate.toDateString()}</td>                    
                    <td className="border p-2 border-2 border-slate-400 rounded text-center">
                        <div className="inline-flex">
                            <button
                                onClick={()=>onEdit(item)}
                                className="bg-gray-300 hover:bg-gray-400 text-sm text-gray-800 font-bold py-2 px-4 rounded-l">
                                Edit
                            </button>                            
                            <button
                                onClick={()=>onDelete(item)}
                                className="bg-gray-300 hover:bg-gray-400 text-sm text-gray-800 font-bold py-2 px-4 rounded-r">
                                Delete
                            </button>
                        </div>
                    </td>
                </tr> })}
        </tbody>
    </table>;
    }
    return <ContainerStyled
        className="mt-2 relative bg-gray-100 dark:bg-gray-900 rounded-lg 
                     flex flex-col justify-start items-start shadow-lg 
                    p-4 overflow-hidden overflow-scroll">
        <div role="status"></div>
        <h2 className="text-gray-700 dark:text-teal-400 text-2xl font-medium mb-2">{title}</h2>
        <p className="text-gray-700 dark:text-gray-300 dartext-base mb-4">
            {subTitle}
        </p>
        <SimpleSpinner display={`inline-block`} loading={!list} title={'Loading promotion...'}/>
        {Boolean(list && list.length > 0) && populateTable()}
    </ContainerStyled>;
};

export default PromotionTableAdmin;